import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import userEventApi from 'api/userEventApi';
import { USER_EVENT_TYPE } from 'constants/constants';
import { dateConversion } from 'helpers/format-time';
import { logout } from '../auth/index';

const initialState = {
  events: [],
  dayEvents: [],
  selectedEvent: undefined,
  selectedSession: undefined,
  unitSelected: undefined,
  record: undefined,
};

export const fetchEvent = createAsyncThunk(
  'calendar/fetchEvent',
  async ({ eventId }, thunkAPI) => {
    const event = await userEventApi.get(eventId);
    return event;
  },
);

export const calendarSlice = createSlice({
  name: 'calendar',
  initialState,
  reducers: {
    getCalendar: (state, action) => {
      state.events = action.payload;
    },
    getDayCalendar: (state, action) => {
      state.dayEvents = action.payload;
    },
    selectEvent: (state, action) => {
      state.selectedEvent = action.payload;
    },
    selectSession: (state, action) => {
      state.selectedSession = action.payload;
    },
    resetEvents: (state, action) => {
      state.events = [];
    },
  },
  extraReducers: {
    [logout]: (state) => initialState,
    [fetchEvent.pending]: (state, action) => {
      state.selectedEvent = {
        isLoading: true,
      };
    },
    [fetchEvent.fulfilled]: (state, action) => {
      state.selectedEvent = action.payload;
    },
    [fetchEvent.rejected]: (state, action) => {
      state.selectedEvent = undefined;
    },
  },
});

// Actions
export const {
  getCalendar,
  getDayCalendar,
  selectEvent,
  selectSession,
  resetEvents,
} = calendarSlice.actions;

// async action
export const getCalendarAsync = (params) => async (dispatch) => {
  const calendar = await userEventApi.getAll(params);
  const now = new Date().getTime();
  const calendarFormat = calendar.map((event) => {
    const editable = new Date(event.time.end).getTime() - now > 0;
    const timeEnd = new Date(event?.time?.end);
    const end = new Date(
      new Date(event?.time?.begin).setHours(
        timeEnd?.getHours(),
        timeEnd?.getMinutes(),
        0,
      ),
    ).toISOString();
    const timeStart = new Date(event?.time?.begin);
    const timeEnds = new Date(event?.time?.end);
    var time_Start = dateConversion(timeStart);
    var time_End = dateConversion(timeEnds);
    return {
      id: event._id,
      title: event?.titleExtenstion
        ? event?.name + ' ' + event?.titleExtenstion
        : event?.importLesson === true
        ? `${event?.name}  ${time_Start.nameOfDay} ${time_Start.getdate}${time_Start.nth} ${time_Start.month} ${time_Start.strTime} - ${time_End.strTime}`
        : event.name,
      start: event?.time?.begin,
      end: end,
      extendedProps: {
        editable,
        ...event,
      },
    };
  });
  return dispatch(getCalendar(calendarFormat));
};

export const getDayCalendarAsync = (params) => async (dispatch) => {
  const calendar = await userEventApi.getAll(params);
  const now = new Date().getTime();

  const calendarFormat = calendar.map((event) => {
    const editable = new Date(event.time.end).getTime() - now > 0;
    const timeEnd = new Date(event?.time?.end);
    const end = new Date(
      new Date(event?.time?.begin).setHours(
        timeEnd?.getHours(),
        timeEnd?.getMinutes(),
        0,
      ),
    ).toISOString();

    const timeStart = new Date(event?.time?.begin);
    const timeEnds = new Date(event?.time?.end);
    var time_Start = dateConversion(timeStart);
    var time_End = dateConversion(timeEnds);
    return {
      id: event._id,
      title: event?.titleExtenstion
        ? event?.name + ' ' + event?.titleExtenstion
        : event?.importLesson === true
        ? `${event?.name} ${time_Start.nameOfDay} ${time_Start.getdate}${time_Start.nth} ${time_Start.month} ${time_Start.strTime} - ${time_End.strTime}`
        : event.name,
      start: event?.time?.begin,
      end: end,
      extendedProps: {
        editable,
        ...event,
      },
    };
  });
  return dispatch(getDayCalendar(calendarFormat));
};

export const getSessionAsync = (eventId) => async (dispatch) => {
  const session = await userEventApi.get(eventId);

  let participants;

  return dispatch(
    selectSession({
      ...session,
      ...(participants && { participants: participants?.data }),
      label: session?.name,
      value: session?._id,
    }),
  );
};

// async action
export const getEventsCourseCalendar = (state) => state.calendar.events;
export const getDayEventsCourseCalendar = (state) => state.calendar.dayEvents;
export const getSelectedEvent = (state) => state.calendar.selectedEvent;
export const getSelectedSession = (state) => state.calendar.selectedSession;

export default calendarSlice.reducer;
